/**
 * Created by ori on 20/09/16.
 */
import apiRequest from '../lib/api-request';
import cookie from 'react-cookie';

export default class Auth {
    constructor(state) {
        this.state = state;
    }

    isLogged(){
        return apiRequest(`user`,`get_current_user`,{});
    }

    old_login(loginData){
        return apiRequest(`user`,`login`,{"loginData":loginData});
    }

    updateUserData() {
        // return apiRequest(`user`,`get_current_user`)
        //     .then(data => this.state.userData = data);
        console.log("-=-=-=-=-");
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/js/actions/Auth.js